import { IBaseCard, IBaseT1Card } from "./base-card.interface";
import { ComputedCard, CosmosEntity } from "./card-basics.interface";

export interface T1RoleUserMapping {
    roleId: string;
    userId: string | null;
}

export interface TaxprepT1Card extends CosmosEntity, ComputedCard {
    id: string;
    cardId: string;
    dashboardId: string;
    return: {
        id: string;
        type: string; // "Taxpayer" | "Spouse" | "Dependant"
        statusId: string;
        statusDate: number;
        statusUserId: string;
    };
    filePath: string;
    categoryId: string | null;
    officeId: string | null;
    group1Id: string | null;
    group2Id: string | null;
    roleUserMapping: T1RoleUserMapping[];
    isSplit?: boolean;
    isVIP: boolean;
    inAlertAt: number | null;
    inDangerAt: number | null;
    name: string;
    contactInformation: {
        firstName: string;
        lastName: string;
        phone: string;
        cellPhone: string;
        email: string;
        iFirmContactId?: string;
    };
    lastYearDocumentsReceivedDate: number | null;
    documentsReceivedDate: number | null;
    lastYearCompletedDate: number | null;
    deadLine: number | null;
    quiet: number | null;
    paymentDate: number | null;
    taxYearEndDate: number | null;
    groupName: string | null;
    note: string | null;
    temporaryNote: string | null;
    clientCodes: {
        clientCodePIN: string | null;
        clientCodeId: string | null;
        clientCodeiFirm: string | null;
    };
    statusesHistory: {
        statusId: string;
        statusDate: number;
        userId: string | null;
    }[];
    lastYearStatusesHistory: {
        statusId: string;
        statusDate: number;
        userId: string | null;
    }[];
    efileStatuses: {
        fedEfileStatus: number;
        provEfileStatus: number;
        t1135EfileStatus: number;
        rC4649EfileStatus: number;
        aT1EfileStatus: number;
    };
    members: {
        cardId: string;
    }[];
    tags: string[];
    originalId: string | null;
    applyStatusToAll: boolean | null;
    applyAssigneesToAll: boolean | null;
    dateNeeded: number | null;
    deliveryMethod: string | null;
}

export function isTaxprepT1Card(card: IBaseCard): card is IBaseT1Card {
    return !!card && "return" in card && card.return != null && "id" in card.return;
}

export type CardsByCardIdMap = Map<string, IBaseCard>;
